import { Action, action, State } from 'easy-peasy';
import { ReactNode } from 'react';

import { MaterialIcons } from '~/app/common/Icon';
import {Archive, Machine, Project} from "~/types";

export interface SetAppHeaderDataPayload {
  backLink?: string | (() => void)
  backLinkIcon?: MaterialIcons
  chatIcon?: MaterialIcons
  notificationIcon?: MaterialIcons
  menuIcon?: MaterialIcons
  searchIcon?: MaterialIcons
  title?: ReactNode
  subTitle?: ReactNode
  showUser?: boolean
  machineId?: Machine['id']
  machineImage?: Machine['machineImage']
  projectId?: Project['id']
  parentFolderId?: Archive['id']
  showMachineMessages?: boolean
  isIssueDetailPage?:boolean
  isServiceDetailPage?: boolean
  notification?: boolean
  search?: boolean
  issueCategorySearch?: boolean
  isTaskPage?: boolean
  isTimeManagementPage?: boolean
  isAddTimeForm?: boolean
  isGridView?: boolean
  openInFull?: boolean
}

export interface AppHeaderModel extends SetAppHeaderDataPayload {
  setData: Action<AppHeaderModel, SetAppHeaderDataPayload>
  clearData: Action<AppHeaderModel>
}

const defaultState: State<AppHeaderModel> = {
  backLink: undefined,
  backLinkIcon: 'arrow_back',
  chatIcon: 'forum',
  notificationIcon: 'notifications',
  menuIcon: 'menu',
  searchIcon: 'search',
  title: undefined,
  subTitle: undefined,
  showUser: false,
  machineId: '',
  projectId: '',
  parentFolderId: 0,
  showMachineMessages: false,
  isIssueDetailPage: false,
  isServiceDetailPage: false,
  notification: false,
  search: false,
  issueCategorySearch: false,
  isTaskPage: false,
  isTimeManagementPage: false,
  isAddTimeForm: false,
  isGridView: false,
  openInFull: false
};

export const appHeaderModel: AppHeaderModel = {
  ...defaultState,
  setData: action((state, payload) => ({ ...defaultState, ...state, ...payload })),
  clearData: action(() => ({ ...defaultState }))
};
